export const SET_DIALING_PLAN = "SET_DIALING_PLAN";
export const SELECT_DIALING_PLAN = "SELECT_DIALING_PLAN";
export const UPDATE_ADD_ON_FEATURES = "UPDATE_ADD_ON_FEATURES";
export const UPDATE_DIALING_PLAN_QUANTITY = "UPDATE_DIALING_PLAN_QUANTITY";
const DEFAULT_PLAN = "PAY_AS_YOU_GO";

export const setDialingPlan = (data) => {
    return (dispatch) => {
        dispatch({type: SET_DIALING_PLAN, newDialingPlanData: data})
    }
}

export const selectDialingPlan = (isUnlimited, planId, planPrice) => {
    return (dispatch, getState) => {
        const { DialingPlan } = getState().DialingPlansReducer;
        
        if(DialingPlan.id == planId && planId != DEFAULT_PLAN) {
            planId = DEFAULT_PLAN;
            planPrice = 10.00;
            isUnlimited = false;
        }
        dispatch({type: SELECT_DIALING_PLAN, isUnlimited, planId, planPrice})
    }
}
export const addReduceDialingPlanQuantity = (isAdding) => {
    return (dispatch, getState) => {
        const { DialingPlan } = getState().DialingPlansReducer;
        if(!DialingPlan.isUnlimited) dispatch(selectDialingPlan(true, "UNLIMITED", 24.99));
        var newQty = 0;
        if(isNaN(DialingPlan.quantity)) {
            newQty = isAdding;
        } else {
            newQty = DialingPlan.quantity + (isAdding ? 1 : -1);
        }
        if(newQty < 0) newQty = 0;
        dispatch({type: UPDATE_DIALING_PLAN_QUANTITY, newQty: Number(newQty)})
    }
}
export const updateDialingPlanQuantity = (newQty) => {
    return (dispatch, getState) => {
        const { DialingPlan } = getState().DialingPlansReducer;
        if(!DialingPlan.isUnlimited) dispatch(selectDialingPlan(true, "UNLIMITED", 24.99));
        if(!isNaN(newQty) && !newQty.includes(".") && newQty.length < 3) {
            dispatch({type: UPDATE_DIALING_PLAN_QUANTITY, newQty: newQty.length > 0 ? Number(newQty) : ""})
        }
    }
}

export const toggleAddOnFeature = (planId, planPrice) => {
    return (dispatch, getState) => {
        var { AddOnFeatures } = getState().DialingPlansReducer;
        if(AddOnFeatures.find(item => item.id == planId)) {
            AddOnFeatures = AddOnFeatures.filter(item => item.id != planId);
        } else {
            AddOnFeatures.push({id: planId, price: planPrice});
        }
        dispatch({type: UPDATE_ADD_ON_FEATURES, AddOnFeatures})
    }
}

export const setAddOnFeatures = (AddOnFeatures) => {
    return (dispatch) => {
        dispatch({type: UPDATE_ADD_ON_FEATURES, AddOnFeatures})
    }
}